module.exports = __webpack_public_path__ + "img/green-texture.82786bf2.png";